<template>
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    :fill="clr"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 16H12V14H4V16ZM4 12H12V10H4V12ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
